import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { CustomerDetailsGeneralDataComponent } from "../customer-details-general-data/customer-details-general-data.component";
import { Customer } from "src/app/models/customer.model";
import { CustomerService } from "src/app/services/customer.service";
import { CommonModule } from "@angular/common";

@Component({
    selector: "customer-dashboard-component",
    templateUrl: "./customer-dashboard.component.html",
    styleUrls: ["./customer-dashboard.component.scss"],
    standalone: true,
    imports: [ButtonModule, CardModule, CommonModule, CustomerDetailsGeneralDataComponent],
    providers: [CustomerService]
})
export class CustomerDashboardComponent {
    @Input() activeTab!: string;
    @Output() activeTabChange = new EventEmitter<string>();
    public customer!: Customer;

    constructor(private customerService: CustomerService) {
        this.customerService.getCustomerByNumber('K2076247-59').subscribe((customer) => {
            this.customer = customer;
        });
    }
}